





































































































































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { ApplicationChangeType} from '../fixed/ApplicationChangeType';
import { ApplicationProcessType} from '../fixed/ApplicationProcessType';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
// 個別
import { loadingControlModule } from '../../store/modules/LoadingControl';

import workTypeList from '../components/WorkTypeConfirmList.vue';
Vue.component('variableWorkTypeList', workTypeList);

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ApplicationFormConstruction extends ApiAccessBase {
  // 処理状況
  protected statusValue: string = '';
  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private exPanelBk: number[] = [];

  // 業者種別
  private traderType = applicationFormModule.GET_APP_TYPE;
  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/application/' + applicationFormModule.GET_APP_TYPE;

  private variableColNames: string[] = [];
  private GROUP_LAYOUT_ARRAY: string = Constants.GROUP_LAYOUT_ARRAY;

  private isOrderUser = supervisingModule.IS_ORDER_USER;
  // 20211002 [01_調達区分_維持管理業務追加] ueda APD Start
  //受付整理票印刷にかかわらず提出ボタンを表示させる
  //private isUketukeDownload = false;
  private isUketukeDownload = true;
  // 20211002 [01_調達区分_維持管理業務追加] ueda APD End

  /**
   * 初期化処理created
   */
  private created() {
    this.screenTitle = '新規/継続申請登録確認';

    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;

    if (!applicationFormModule.IS_SET_CHANGE_TYPE) {
      // 通常の修正
      path = path + '/get_confirm/normal';
    } else {
      // 継続（修正）
      path = path + '/get_confirm/continue';
    }
    path = path + '/' + applicationFormModule.GET_TRADER_ID;

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        let panelIndex = 0;
        for (const variablecol of Object.keys(this.variablecols)) {
          if (variablecol !== 'local_info') {
            // パネル設定全オープン
            this.exPanel.push(panelIndex);
            panelIndex++;
            this.variableColNames.push(variablecol);
          }
        }
        this.exPanelBk = this.exPanel.concat();
        // 処理状況表示
        this.statusValue = '処理状況：' + this.formData.status;
        if (this.formData.status.substring(0, 3) !== '入力中') {
          this.isUketukeDownload = true;
        }
        // 受付整理票関連制御
        if (!this.colInfo.uksButton) {
          this.isUketukeDownload = true;
        }
      }
    });
  }

  /**
   * 申請書提出
   */
  private registAppForm() {

    let path = this.APP_PATH;
    path = path + '/submit/' + applicationFormModule.GET_TRADER_ID;

    // 登録
    this.apiAccess(path, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        applicationFormModule.setIsSubmitEnd(true);
        //排他解除前にメッセージ保持
        const successMessage = this.infoMessage;
        //排他解除
        //20220104 完了メッセージ表示対応　ADD START JINNO
        this.deleteExclusive(successMessage);
        // this.deleteExclusive();
        //20220104 完了メッセージ表示対応　ADD END JINNO
        //排他解除後にメッセージ格納
        this.infoMessage = successMessage;
      }
    });
    // 先頭へジャンプ
    this.hrefElement('af-const', -50);
  }

  /**
   * 戻るボタンの処理
   */
  private returnFunc() {
    if (this.isSubmitEnd()) {
      this.returnSearchOrMenu();
    } else {
      this.returnPrevious();
    }
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    router.push('appForm');
  }

  /**
   * 排他レコードの削除
   */
  private deleteExclusive(successMessage : string) {
    if (supervisingModule.CHECK_MODE_UPDATE) {
      this.apiAccess(this.APP_PATH + '/exclusive/' + applicationFormModule.GET_TRADER_ID, Constants.API_METHOD_POST, false, true)
      .then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          //20220104 完了メッセージ表示対応　ADD START JINNO
          this.infoMessage = successMessage;
          ////20220104 完了メッセージ表示対応　ADD END JINNO
          //継続申請時の前回データも解除
          if (applicationFormModule.IS_SET_BEFORE_TRADER_ID) {
            this.apiAccess(this.APP_PATH + '/exclusive/' + applicationFormModule.GET_BEFORE_TRADER_ID, Constants.API_METHOD_POST, false, true)
            .then((result2) => {
              //20220104 完了メッセージ表示対応　ADD START JINNO
              this.infoMessage = successMessage;
              //20220104 完了メッセージ表示対応　ADD END JINNO
            });
          }
        }
      });
    }
  }
  /**
   * 検索画面or受注者メニュー画面に戻る
   */
  private returnSearchOrMenu() {
    applicationFormModule.moduleResetDetail();
    if (supervisingModule.IS_ORDER_USER) {
      router.push({name: applicationFormModule.GET_TRANSITION_SOURCE_SCREEN});
    } else {
      router.push('accepterMainMenu');
    }
  }

  private exPanelAllClose() {
    this.exPanel = [];
  }
  private exPanelAllOpen() {
    this.exPanel = this.exPanelBk.concat();
  }
  /**
   * 受付整理票印刷
   */
  private uketsukeDownload() {
    let path = this.APP_PATH;
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      path = path + '/uketsukehyo' + '/' + applicationFormModule.GET_TRADER_ID;
      this.apiAccessDownload(path);
      this.isUketukeDownload = true;
    }
  }
  private screenPrint() {
    // window.print();
    router.push('appFormConfirmPrint');
  }

  private isSubmitEnd() {
    return applicationFormModule.isSubmitEnd;
  }
  //20241118 [appListPrint++] a-matsui del start
  //20240901 [appListPrint] a-matsui add start
  //private appList() {
  //  router.push('applicationListPrint');
  //}
  //20240901 [appListPrint] a-matsui add end
  //20241118 [appListPrint++] a-matsui del end
}
